import {createTransform, persistCombineReducers} from 'redux-persist';
import storage from 'redux-persist/lib/storage'
import {createResponsiveStateReducer} from 'redux-responsive';
import { connectRouter } from 'connected-react-router'
import {createBrowserHistory} from 'history';

import omit from 'lodash/omit';
import pick from 'lodash/pick';

import ui from './ui/reducer';
import appInfo from './appInfo/reducer';
import tables from './tables/reducer';
import orders from './orders/reducer';
import modals from './modals/reducer';
import filters from './filters/reducer';

import {cachedTables, fullCachedTables, sortAndFieldsCachedTables} from './constants';

export const history = createBrowserHistory();

const tablesTransform = createTransform(
    (inboundState) => {
        const tables = {};

        cachedTables.map(tableName => tables[tableName] = omit(inboundState[tableName], 'data', 'loading', 'error'));
        fullCachedTables.map(tableName => tables[tableName] = omit(inboundState[tableName], 'loading', 'error'));
        sortAndFieldsCachedTables.map(tableName => tables[tableName] = pick(inboundState[tableName], ['sort', 'fields']));

        return tables;
    },
    (outboundState) => outboundState,
    {whitelist: [`tables`]}
);

const uiTransform = createTransform(
    (inboundState) => {
        return {
            sidebar: pick(inboundState.sidebar, ['isCollapsed']),
            filters: pick(inboundState.filters, ['isCollapsed']),
            deposit: pick(inboundState.deposit, ['method', 'amount']),
            streamerTimePeriod: inboundState.streamerTimePeriod,
        };
    },
    (outboundState) => outboundState,
    {whitelist: [`ui`]}
);


const persistConfig = {
    key: 'app',
    storage,
    whitelist: ['tables', 'ui', 'filters'],
    transforms: [
        tablesTransform,
        uiTransform,
    ],
};

const persistReducers = persistCombineReducers(persistConfig, {
    ui,
    tables,
    appInfo,
    orders,
    modals,
    filters,
    router: connectRouter(history),
    viewport: createResponsiveStateReducer({
        tiny: 370,
        extraSmall: 480,
        intermediateSmall: 667,
        small: 768,
        intermediateMedium: 800,
        medium: 992,
        intermediate: 1024,
        middle: 1120,
        large: 1366,
        huge: 1920,
    }),
});


export default persistReducers;
